/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Pool_Game_WinnersInputs */



/**
* | output |
* | --- |
* | "Game winners" |
*
* @param {Raffle_Pool_Game_WinnersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_pool_game_winners = /** @type {((inputs?: Raffle_Pool_Game_WinnersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Pool_Game_WinnersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vainqueurs de partie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ganadores de partida")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vencedores de partida")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vincitori di partita")
	return /** @type {LocalizedString} */ ("Game winners")
});